import { render, staticRenderFns } from "./sec-logospatrocinio.vue?vue&type=template&id=0005ccb2&"
import script from "./sec-logospatrocinio.vue?vue&type=script&lang=js&"
export * from "./sec-logospatrocinio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports